import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "22",
        cy: "22",
        r: "22",
        fill: "var(--status-svg-color)"
      }),
      _createElementVNode("path", { d: "M11 11h22v22H11z" }),
      _createElementVNode("path", {
        fill: "#FFF",
        "fill-rule": "nonzero",
        d: "M26.5 13.8h3.6a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H13.9a.9.9 0 0 1-.9-.9V14.7a.9.9 0 0 1 .9-.9h3.6V12h1.8v1.8h5.4V12h1.8zm2.7 7.2H14.8v7.2h14.4zm-4.5-5.4h-5.4v1.8h-1.8v-1.8h-2.7v3.6h14.4v-3.6h-2.7v1.8h-1.8zm-8.1 7.2h1.8v1.8h-1.8zm4.5 0h1.8v1.8h-1.8zm4.5 0h1.8v1.8h-1.8z"
      })
    ], -1)
  ]))]))
}
export default { render: render }